let pendingPageViewExtras: Record<string, string | number> | undefined;

export function setPendingPageViewExtras(extras: Record<string, string | number>): void {
  pendingPageViewExtras = extras;
}

export function consumePendingPageViewExtras(): Record<string, string | number> | undefined {
  const extras = pendingPageViewExtras;
  pendingPageViewExtras = undefined;
  return extras;
}
